export const ConditionalRenderer = ({ condition, children }) => {
    if (condition) {
        return children;
    }

    return null;
};
